import styled from 'styled-components/macro'

export const ReadMore = styled.span`
  display: block;
  max-width: calc(10 * var(--grid-size) + 9 * var(--gap-size));
  margin: 0 auto;
  padding: 0.8rem;
  text-align: center;
  border-top: 1px solid currentColor;

  &:not(:hover) {
    color: inherit;
  }
`
